const y2Regex =
    /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/;

export const isYoutube = (stream) => stream?.search('youtu') !== -1;

export const y2Thmbnail = (stream) => {
    const videoId = stream?.match(y2Regex);

    if (videoId != null) {
        return `https://i.ytimg.com/vi/${videoId[1]}/hqdefault.jpg`;
    }
};

export const y2Embed = (stream) => {
    const videoId = stream?.match(y2Regex);

    if (videoId != null) {
        return `https://www.youtube.com/embed/${videoId[1]}/1.jpg`;
    }
};

export const fbEmbed = (stream) =>
    `https://www.facebook.com/plugins/video.php?href=${stream}`;
